import request from '@/axios'

// 获取通用枚举
export const getEnumApi = () => {
  return request.get({ url: '/systems/common/enum' })
}

// 获取字典
export const getDictOneApi = async (code: string) => {
  return request.get({ url: '/systems/common/business-tree' ,params: { code }})
}
